import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import PromotionSelector from "../components/PromotionSelector";
import { NavigationContext, UserContext } from "../contexts";
import { getPageTitle } from "../resources/routes";
import { Promotion } from "../types";
import { scrollToTop } from "../util";

const PromotionsScreen = observer(() => {
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);
  const location = useLocation();

  useEffect(() => {
    scrollToTop();
    navContext.resetNextBtn();
    navContext.resetBackBtnOnClick();
    navContext.setFooterModePrimary();
    navContext.setNextButtonEnabled(true);

    navContext.setOnNavigateBack(() => {
      // Reset selection when the user goes back
      userContext.setSelectedPromotion(null);
      navContext.setOfferTickerVisible(false);
    });

    return () => {
      navContext.setOfferTickerVisible(false);
    };
  }, []);

  const onClickItem = (item: Promotion) => {
    if (
      userContext.selectedPromotion &&
      userContext.selectedPromotion.id === item.id
    ) {
      userContext.setSelectedPromotion(null);
      navContext.setOfferTickerVisible(false);
    } else {
      userContext.setSelectedPromotion(item);
      navContext.setOfferTickerVisible(true);
    }
  };

  return (
    <div className={"screen screen-choose-kitchen-style"}>
      <div className={"container"}>
        <h2 className="h1">{getPageTitle(location.pathname)}</h2>
        <p className={"subtitle"}>
          Select our current promotion, available only for a limited time.
        </p>
        <p className={"section-label"}>Select your Promotions</p>
      </div>
      <PromotionSelector
        promotions={userContext.promotions}
        selectedPromotion={userContext.selectedPromotion}
        onClickPromotion={onClickItem}
      />
    </div>
  );
});

export default PromotionsScreen;
